import { render, staticRenderFns } from "./TipoMovVal.vue?vue&type=template&id=680ec64e&"
import script from "./TipoMovVal.vue?vue&type=script&lang=js&"
export * from "./TipoMovVal.vue?vue&type=script&lang=js&"
import style0 from "./TipoMovVal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports